function gridUpdates(){
  const changeGrid = document.querySelectorAll(".button_change_grid");
  changeGrid.forEach((element) => {
    element.addEventListener(
      "change",
      function () {
        const grid = document.querySelector("#product-grid");
        grid.dataset.grid = element.value;
      },
      false
    );
  });

  // Remove plus-clicked class when clicking outside or swiping down
  document.addEventListener("swiped-down", function ({ target }) {
    target.closest(".card-wrapper.plus-clicked")?.classList.remove("plus-clicked");
    target.closest('.card-wrapper')?.querySelector('.overlay-variant-radios').classList.add('hidden');
  });
}

document.addEventListener('DOMContentLoaded', gridUpdates)